<script lang="ts" context="module">
</script>

<script lang="ts">
  import Truncate from '$lib/components/Truncate.svelte';
  import MainContainer from '../../_util/MainContainer.svelte';
  import NavLink from '$lib/components/NavLink.svelte';
  import CopyButton from '$lib/components/CopyButton.svelte';
  import SocialLinks from '$lib/components/SocialLinks.svelte';
  import { shortAddress } from '$lib/format';
  import { setupReload } from '$lib/api';
  import ReportModal from '$lib/components/ReportModal.svelte';
  import MainContent from '$lib/components/MainContent.svelte';
  import type { LayoutData } from './$types';
  import BootstrapLayout from '../../_util/BootstrapLayout.svelte';

  export let data: LayoutData;

  $: ({ addresses, profile, username, isTestMode, testAppId, isCurrentUserProfile, dependencies } =
    data);

  $: address = addresses?.[0];

  $: profileImageUrl = profile?.imageUrl || `https://www.bitski.com/${username}/image`;

  setupReload(() => dependencies, {
    shouldReloadWithBackoff: () => !profile,
  });
</script>

<BootstrapLayout />
<MainContainer dark>
  <MainContent>
    {#if !profile}
      <div class="h-full w-full flex flex-grow justify-center items-center">
        <i class="icon-spinner text-grey-aux w-16 h-16" />
      </div>
    {:else}
      <div class="w-full">
        <div
          class="absolute w-screen h-30 md:h-48 top-0 left-0 -z-1 border-brand"
          class:border-b-2={isTestMode}
        >
          <div
            class="w-full h-full bg-cover bg-center"
            style="background-image: url({profileImageUrl});"
          >
            <div class="backdrop-blur-2xl w-full h-full" />
            <div
              class="absolute top-0 bg-gradient-to-b from-transparent to-white dark:to-background-aux w-full h-full"
            />
          </div>

          {#if isTestMode}
            <div
              class="absolute helper bg-brand text-white rounded-b-sm px-2 left-1/2 -bottom-5 -translate-x-2/4"
            >
              Test data
            </div>
          {/if}
        </div>
        <div class="pt-11 md:pt-24">
          <div class="relative text-right">
            <img
              src={profileImageUrl}
              alt={username}
              class="avatar w-20 h-20 border-4 md:w-24 md:h-24 absolute bottom-0 md:bottom-4"
            />

            <div class="inline-block mt-2 md:mt-0">
              {#if isCurrentUserProfile}
                <a href="https://user.bitski.com/settings" class="btn btn-sm btn-grey mr-1">
                  Settings
                </a>
                <a href="https://wallet.bitski.com" class="btn btn-sm btn-primary">View wallet</a>
              {:else if address}
                <CopyButton copyText={address} className="btn btn-sm btn-grey">
                  {shortAddress(address)}
                  <i class="icon-copy icon-right" />
                </CopyButton>
              {/if}
            </div>
          </div>
          <h1 class="heading-3 md:heading-2 mt-2 md:mt-0">
            @{username}

            <SocialLinks {profile} className="hidden md:inline ml-1" />
          </h1>
          <p class="body-bold mt-2 profile-description break-words whitespace-pre-line">
            <Truncate text={profile.description ?? ''} limit={112} />
          </p>

          <SocialLinks {profile} className="md:hidden inline-block mt-2" />
          <div class="tabs mt-4 md:mt-6">
            <NavLink href="/@{username}{testAppId ? `+test${testAppId}` : ''}/created"
              >Created</NavLink
            >
            <NavLink href="/@{username}{testAppId ? `+test${testAppId}` : ''}/collected"
              >Collected</NavLink
            >
            {#if address}
              <NavLink
                href="/@{username}{testAppId ? `+test${testAppId}` : ''}/statistics/{address}"
                >Stats</NavLink
              >
            {/if}
          </div>
        </div>
      </div>

      <slot />
    {/if}

    <ReportModal type="profiles" id={username} />
  </MainContent>
</MainContainer>

<style lang="postcss">
  .-z-1 {
    z-index: -1;
  }

  .profile-description {
    max-width: 30rem;
  }
</style>
